/** Canonical React Query keys for workspace-scoped agent definitions. */
export const agentQueryKeys = {
  all: ['agents'] as const,
  workspace: (workspaceId: string, includeDeleted = false) =>
    ['agents', workspaceId, { includeDeleted }] as const,
  detail: (workspaceId: string, agentId: string) =>
    ['agent', workspaceId, agentId] as const,
}

/** Topic detail keys remain below the `topics` prefix so existing websocket
 * prefix invalidation refreshes authoritative detail reads as well as lists. */
export const topicQueryKeys = {
  all: ['topics'] as const,
  workspace: (workspaceId: string) => ['topics', workspaceId] as const,
  detail: (topicId: string) => ['topics', 'detail', topicId] as const,
}

/** Model availability depends on both provider identity and expected
 * workspace; omitting the workspace would allow cross-workspace cache reuse. */
export const providerQueryKeys = {
  models: (workspaceId: string, providerId: string) =>
    ['provider-models', workspaceId, providerId] as const,
  profile: (workspaceId: string, providerId: string, model: string) =>
    ['provider-model-profile', workspaceId, providerId, model] as const,
}
